import Sentry from 'sentry';

global.HARA = {
    branch: 'hara',
    defaults: {'ded' : 1,
	       'mins' : 1},
    // dry-run marker:
    dry: true,
    // Fahrrad-Einschluss wahlweise in abs. Betrag oder in Prozent:
    frd: 1,

    o_possible: true,
    // Premium Plus Variante
    plus: false,
    type: 'hara',
    vs: 0,
    // vtype ist vs oder wf für VS bzw. WF-Modell
    vtype: '',
    wf: 0,

    canCalc: function(e) {
	BC.debug('HARA.canCalc(): Checking ...', '', 64);
	HARA.o_possible = HARA.haveRisk(e) && HARA.chkWF(e) && HARA.havePeril(e);
	PRIV.calcable = HARA.o_possible;
	return HARA.o_possible;
    },

    change: function(e) {
        var b = e ? ALL.get_branch(e) : ALL.get_branch(this);
		BC.debug('HARA.change(): starting', [e, b, ALL.get_branch(this)], 64);
        //if (b == 'vn' || b.slice(0, 2) == 'da') return;
		if (! HARA.type || HARA.type !== PRIV.get_branch(this)) {
				HARA.type = PRIV.get_branch(this);
				BC.debug('HARA.change(): HARA.type was unknown or wrong, set to ' + HARA.type, 64);
			}
		JQ('#f_' + HARA.type + '_f_1').prop('disabled', false);
		//if (ALL.chkChkBox('f_' + HARA.type + '_dnls'))
        ALL.chkDate(JQ('#f_' + HARA.type + '_ende'));
		if (! HARA.haveRisk(e)) {
			if (! ALL.mobile) {
			ALL.chgProduct(HARA.type, null);
			} else {
			BC.debug('HARA.change(); mobile, missing risk', '', 64);
			HARA.chkDivReady(e.target);
			}
			JQ('#f_' + HARA.type + '_f_1').prop('disabled', true);
			ALL.notifyHeight();
			return;
		}

		if (JQ('#div_phvo_vers').is(":hidden")) {
		    JQ('#div_' + HARA.type + '_vers').show();
		}

		if (! HARA.havePeril(e)) {
			ALL.chgProduct(HARA.type, null);
		} else {
				if (ALL.mobile && ALL.steps[0] > 3) {
					// No need for recalc! But for call of chgProduct?
                    ALL.chgProduct(HARA.type, 1);
                    ALL.notifyHeight();
					return;
				}
			if (JQ('#f_hara2_plus_1').prop('checked') === true) {
				JQ('#div_hara2_marktgarantie').show();
				JQ('#p_hara2_marktgarantie').parent().show();
			} else {
				JQ('#div_hara2_marktgarantie').hide();
				JQ('#p_hara2_marktgarantie').parent().hide();
				JQ('#f_hara2_marktgarantie_0').prop("checked", true);
			};
			if (parseInt(JQ('#f_'+HARA.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+HARA.type+'_rbt_bundle_text').val().length === 0 || !HARA.o_possible) {
				JQ('#b_' + HARA.type + '_go2datavn').button("option", "disabled", true);
				JQ('#vs-nr-hint-' + HARA.type).show();
				JQ('#f_'+HARA.type+'_rbt_bundle_text').focus();
			} else {
				JQ('#vs-nr-hint-' + HARA.type).hide();
				JQ('#b_' + HARA.type + '_go2datavn').button("option", "disabled", false);
			}
			HARA.recalc();
			ALL.notifyHeight();
		}
    },

    chgWF2: function() {
        if (JQ('#f_' + HARA.type + '_wf2').val() &&
            JQ('#f_' + HARA.type + '_wf2').val() != JQ('#f_' + HARA.type + '_wf').val()) {
            JQ('#f_' + HARA.type + '_wf').val(JQ('#f_' + HARA.type + '_wf2').val());
            HARA.chkWFVS();
        }
    },

    chkDivComplete: function() {
        if (! HARA.chkDivReady(this)) {
            BC.debug('HARA.chkDivComplete called by ', BC.get_id(this), 64);
        }
    },

    chkDivReady: function(btn) {
	var r;
        BC.debug('HARA.chkDivReady():', btn, 64);
	try {
	    var b = BC.get_id(btn);
            var p = ALL.get_box_id(b);
            if (! p) return false;
	    var d = BC.get_id(p);
	}
	catch (e) {
	    BC.debug('HARA.chkDivReady() rised an exception:', e, 16);
		Sentry.captureException(e);
	    return false;
	}
        if (! d) return false;
	BC.debug('HARA.chkDivReady() called for ' + b + ' in ' + d, btn, 64);
        ALL.chkDivReady(d, true);
	switch(d) {
	case '#div_0':
	    return true;
	case '#div_1':
	    if (JQ('#f_' +  HARA.type + '_plz').val() &&
		JQ('#f_' +  HARA.type + '_wf').val()) {
		BC.debug('HARA.chkDivReady(): ' + d + ' is ready!', '', 64);
		JQ('#f_hara2_plz2').val(JQ('#f_hara2_plz').val());
		JQ('#f_hara2_wf2').val(JQ('#f_hara2_wf').val());
		return true;
	    }
	    ALL.chgMobButton('#btn_fwd_1', false);
	    break;
	case '#div_2':
	    if ((JQ('#f_' +  HARA.type + '_itype_1').is(':checked') ||
		 JQ('#f_' +  HARA.type + '_itype_2').is(':checked')) &&
		JQ('#f_' +  HARA.type + '_ded_1').is(':checked') &&
		JQ('#f_' +  HARA.type + '_mins_1').is(':checked')) {
		BC.debug('HARA.chkDivReady(): ' + d + ' is ready!', '', 64);
		ALL.steps[1] = 3;
		return true;
	    }
	    ALL.chgMobButton('#btn_fwd_2', false);
	    break;
	case '#div_3':
	    if ((JQ('#f_' +  HARA.type + '_el_0').is(':checked') ||
		 JQ('#f_' +  HARA.type + '_el_1').is(':checked')) &&
		ALL.steps[1] >= 3) {
		ALL.steps[1] = 4;
		BC.debug('HARA.chkDivReady(): ' + d + ' is ready!', '', 64);
		if (parseInt(JQ('#f_'+HARA.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+HARA.type+'_rbt_bundle_text').val().length === 0) {
			JQ('#vs-nr-hint-hara2').show();
	    	ALL.chgMobButton('#btn_fwd_3', false);
		} else {
			JQ('#vs-nr-hint-hara2').hide();
			return true;
		}
	    }
	    ALL.chgMobButton('#btn_fwd_3', false);
	    break;
	case '#div_4':
	    if (ALL.isVNcompleted() && ALL.haveVN() && ALL.steps[1] >= 4) {
		BC.debug('HARA.chkDivReady(): ' + d + ' is ready!', '', 64);
		// It's time to fetch an offer-ID:
		// (but only if btn_fwd_4 is pressed)
		// Disabled on 2018-11-19: We now use submit to /TR/anda,
		// no need to prefetch an offer-ID
		if (b.slice(0, 4) == '#btn') PRIV.get_onr();
		return true;
	    }
	    break;
	case '#div_5':
            HARA.setChkFlds();
	    r = PRIV.chkDA0();
	    BC.debug('HARA.chkDivReady(): #div_5 ready is', r, 64);
	    if (r) return true;
	    BC.debug('HARA.chkDivReady(): #div_5 is NOT ready!', '', 64);
	    //ALL.chgMobButton('#btn_fwd_5', false);
            break;
	case '#div_98':
	    return true;
	case '#div_99':
            JQ('#div_'  +  HARA.type + '_rslt').hide();
		ALL.triggerDataLayerEvent('Hausrat', HARA.type);
	    return true;
	default:
	    BC.debug('HARA.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
	    break;
	}
	BC.debug('HARA.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
	return false;
    },

    chkKeys: function(e) {
	BC.debug('HARA.chkKeys(): called', e, 64);
	var plz = JQ('#f_' + HARA.type + '_plz').val();
	var wf = JQ('#f_' + HARA.type + '_wf').val();
        var plzi, wfi;
	BC.debug('HARA.chkKeys(): key pressed: ' + e.key +
		  ' plz.len=' + plz.length + ' wf.len=' + wf.length, '', 64);
	try {
	    plzi = parseInt(plz);
	    wfi  = parseInt(wf);
	}
	catch(e) {
	    BC.debug('HARA.chkKeys(): raised exception:', e, 64);
	    wfi = 0;
	    plzi = 0;
	}
        if (plz.length == 5 && plzi > 1000) {
            BC.debug('HARA.chkKeys(): Moving focus to WF', '', 64);
            JQ('#f_' + HARA.type + '_wf').focus();
        }
	if (! isNaN(plzi) && ! isNaN(wfi) && plz.length == 5 && wf.length >= 2 && plzi >= 1000 && plzi <= 99999) {
            if (wfi >= 25 && wfi <= 250) {
	        BC.debug('HARA.chkKeys(): 1st calc is possible!', '', 64);
	        ALL.chgMobButton('#btn_fwd_1', true);
	        HARA.change();
	        return;
	    } else {
	        BC.debug('HARA.chkKeys(): 1st calc is NOT possible!', '', 64);
		ALL.chgProduct(HARA.type, 0);
            }
        }
	ALL.chgMobButton('#btn_fwd_1', false);
    },

    chkWFVS: function(e) {
	// Wenn VS leer oder 0 => WF-Modell
	// Bei WF-Modell muss WF <= 100 sein
	// Standardmaessig VS mit WF * 650 vorbelegen
	HARA.setType();
	var wf = parseInt(JQ('#f_' + HARA.type + '_wf').val());
	var vs = JQ('#f_' + HARA.type + '_vs').val();
	var hara_vs;
	vs = vs ? parseInt(vs) : 0;
	BC.debug('HARA.chkWFVS(): TYPE, WF, VS:', [HARA.type, wf, vs], 64);
	if (HARA.type == 'hara2' &&
	    (! JQ('#f_' + HARA.type + '_vs').val() ||
	     wf != HARA.wf)) {
	    HARA.vs = Math.min(Math.ceil(wf * 0.65), 250);
	    BC.debug('HARA.chkWFVS(): Missing VS or changed WF, setting VS to ' + HARA.vs, '', 64);
	    if (ALL.mobile) {
		JQ('#f_' + HARA.type + '_vs').val(HARA.vs + '.000');
	    } else {
		JQ('#f_' + HARA.type + '_vs').val(HARA.vs);
	    }
	    HARA.wf = wf;
	} else {
	    // Shorten VS if in 1 EUR instead of 1000 EUR:
	    if (vs > 1000) vs = Math.floor(vs / 1000);
	    BC.debug('HARA.chkWFVS(): Fixing VS to ' + vs)
	    HARA.vs = vs;
	}
	BC.debug('HARA.chkWFVS(): TYPE=' + HARA.type + ', WF=' + HARA.wf + ', VS=' + HARA.vs, this.id, 64);
	if (HARA.type == 'hara2' && HARA.vs && (HARA.vs < 17 || HARA.vs > 250)) {
	    BC.debug('HARA.chkWFVS() => HARA2.vs = ', HARA.vs, 64);
	    ALL.showHint('Hausrat: Die Versicherungssumme muss mindestens 17.000 € und darf maximal 250.000 € betragen.');
	    HARA.vs = 17;
	    JQ('#f_' + HARA.type + '_vs').val(HARA.vs);
	    if (ALL.mobile) JQ('#f_' + HARA.type + '_vs').val(HARA.vs + '.000');
	} else if (HARA.type == 'hara2' && ! HARA.vs) {
	    ALL.showHint('Hausrat: Die Mindestversicherungssumme beträgt 17.000 €, ohne Eingabe einer VS ist eine Berechung nicht möglich.');
	    HARA.vs = 17;
	    JQ('#f_' + HARA.type + '_vs').val(HARA.vs);
	    if (ALL.mobile) JQ('#f_' + HARA.type + '_vs').val(HARA.vs + '.000');
	}
	if (HARA.wf > 250 || HARA.wf < 25) {
	    ALL.showHint('Hausrat: Die Wohnfläche muss mindestens 25 qm und darf maximal 250 qm betragen.');
	    JQ('#f_' + HARA.type + '_wf').val(25);
	    return false;
	}
	HARA.vtype = '';
	if (HARA.wf == 0 || this.id == 'f_hara2_wf' || JQ('#f_' + HARA.type + '_wf2').length) {
	    if (! JQ('#f_' + HARA.type + '_vs').val() || ! HARA.vs) {
		HARA.vs = Math.min(Math.ceil(HARA.wf * 0.65), 250);
		JQ('#f_' + HARA.type + '_vs').val(HARA.vs);
	    }
	    JQ('#f_' + HARA.type + '_wf2').val(HARA.wf);
	    JQ('#m002_wf').text(HARA.wf);
	    JQ('#m002_plz').text(HARA.plz);
	    JQ('#m098_wf').text(HARA.wf);
	    if (ALL.mobile) JQ('#f_' + HARA.type + '_vs').val(HARA.vs + '.000');
	}
	if (HARA.vs && HARA.vs / HARA.wf < 0.65) {
	    // VS-Modell und UVZ => NEIN
	    JQ('#s_' + HARA.type + '_uvz').text('Nein').css({'color': 'red',
							     'font-weight': 'bold'});
	    HARA.showBikeDiv('vs');
	    HARA.vtype = 'vs';
	} else if (HARA.vs) {
	    // VS-Modell
	    JQ('#s_' + HARA.type + '_uvz').text('Ja').css({'color': 'green',
							   'font-weight': 'bold'});
	    HARA.showBikeDiv('vs');
	    HARA.vtype = 'vs';
	} else if (HARA.type != 'hara2' && HARA.wf <= 100) {
	    // WF-Tarif
	    JQ('#s_' + HARA.type + '_uvz').text('Wohnflächentarif, Höchstentschädigung max. 100.000 € inkl. Kosten');
	    JQ('#s_' + HARA.type + '_uvz').css({'color': '', 'font-weight': ''});
	    HARA.showBikeDiv('wf');
	    HARA.vtype = 'wf';
	} else {
	    JQ('#s_' + HARA.type + '_uvz').text('');
	    ALL.showHint('Bitte geben Sie eine Versicherungssumme ein.');
	    HARA.showBikeDiv('');
	    return false;
	}
    },

    chkWF: function(event) {
	// WF muss >= 50 und <= 250 sein
	var hara_wf = parseInt(JQ('#f_' + HARA.type + '_wf').val());
	if (HARA.type == 'hara' && (hara_wf > 250 || hara_wf < 50)) {
	    ALL.showHint('Hausrat: Die Wohnfläche muss mindestens 50 qm und darf maximal 250 qm betragen.');
	    JQ('#f_' + HARA.type + '_wf').val(50);
	    return false;
	} else if (HARA.type == 'hara1' && (hara_wf > 250 || hara_wf < 25)) {
	    ALL.showHint('Hausrat: Die Wohnfläche muss mindestens 25 qm und darf maximal 250 qm betragen.');
	    JQ('#f_' + HARA.type + '_wf').val(25);
	    return false;
	}
	return true;
    },

    havePeril: function(e) {
	BC.debug('HARA.havePeril(' + HARA.type + '): Checking ...', '', 64);
	var valid = true;
	PRIV.bparts[HARA.type] = [];
	HARA.plus = JQ("#f_" + HARA.type + "_plus_1").is(':checked');
	if (! ALL.mobile && ! JQ("#f_" + HARA.type + "_f_1").is(':checked')) {
	    BC.debug('HARA.havePeril(' + HARA.type + '): Missing hara_f', '', 64);
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte mindestens Feuer als zu versichernde Gefahr angeben.', 1);
	    }
	    valid = false;
	    JQ('#div_' + HARA.type + '_vers_1').hide();
	} else {
	    JQ('#div_' + HARA.type + '_vers_1').show();
	    if (HARA.type == 'hara2') HARA.chkWFVS();
	}
	// if (e && e.target.id == 'f_hara2_plus_0') {
	//     // Fahrrad auf 0 setzen, wenn Plus nicht ausgewählt - ticket:251
	//     HARA.setBike0();
	// }
	var gl = JQ("input[type=radio][name=hara1_glas]:checked").val();
	var hasHara2Glas = JQ("#f_hara2_glas_1").is(':checked');

	if (gl in ['1', '2', '3']) {
	    PRIV.bparts[HARA.type].push('glas');
	} else if (hasHara2Glas) {
	console.warn('HARA2 Glas selected')
        PRIV.bparts[HARA.type].push('glas');
	} else {
	    PRIV.bparts[HARA.type] = PRIV.bparts[HARA.type].filter(function(x) {return x != 'glas';});
	}
	if (HARA.vtype) PRIV.bparts[HARA.type].push(HARA.vtype);
	JQ('.display-on-esg_' + HARA.type).hide();
	JQ('.hide-on-esg_' + HARA.type).show();
    if (JQ("#f_" + HARA.type + "_esg").is(':checked') && JQ('#f_' + HARA.type + '_esg').val() == '1' && PRIV.bparts[HARA.type].indexOf('esg') < 0) {
	    PRIV.bparts[HARA.type].push('esg');
	    JQ('.display-on-esg_' + HARA.type).show();
	    JQ('.hide-on-esg_' + HARA.type).hide();
	}
	BC.debug('HARA.havePeril(' + HARA.type + '): =>', valid, 64);
	HARA.o_possible = valid;
	ALL.notifyHeight();
	return valid;
    },

    haveRisk: function(e) {
	HARA.setType();
	BC.debug('HARA.haveRisk(' + HARA.type + ' / ' + ALL.get_branch(this) + '): Checking, mobile: ' + ALL.mobile, '', 64);
	// valid = true : Alle Risikomerkmale vorhanden
	var valid = true;
	var _plz = parseInt(JQ('#f_' + HARA.type + '_plz').val());
	var _str = JQ('#f_' + HARA.type + '_str').val();
	var _hnr = JQ('#f_' + HARA.type + '_hnr').val();
	PRIV.vv.vv3  = JQ('#f_' + HARA.type + '_vv3').val();
	var _wf = parseInt(JQ('#f_' + HARA.type + '_wf').val());
	if (! _plz) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte die PLZ angeben.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing plz for ', HARA.type, 64);
	    valid = false;
	}
	if (valid && ! _str) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte die Strasse (ohne Hausnummer) eingeben.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing str for ', HARA.type, 64);
	    if (! ALL.mobile) valid = false;
	}
	if (valid && ! _hnr) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte die Hausnummer eingeben.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing hnr for ', HARA.type, 64);
	    if (! ALL.mobile) valid = false;
	}
	if (valid && ! _wf) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte die Wohnfläche eingeben.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing hara_wf', null, 64);
	    valid = false;
	}
	if (valid && ALL.mobile && ALL.steps[0] == 1 &&
	    ! JQ("#f_" + HARA.type + "_plus_1").is(':checked') &&
	    ! JQ("#f_" + HARA.type + "_plus_0").is(':checked')) {
	    BC.debug('HARA.haveRisk(): Missing hara_plus', '', 64);
	    valid = false;
	}
	if (valid && ALL.mobile && ALL.steps[0] == 2) {
	    if (! JQ("#f_" + HARA.type + "_itype_1").is(':checked') &&
		! JQ("#f_" + HARA.type + "_itype_2").is(':checked')) {
		valid = false;
		BC.debug('HARA.haveRisk(): Missing itype', '', 64);
	    } else if (! JQ("#f_" + HARA.type + "_ded_1").is(':checked') &&
                       ! JQ("#f_" + HARA.type + "_ded_2").is(':checked')) {
		valid = false;
		BC.debug('HARA.haveRisk(): Wrong ded', '', 64);
	    } else if (! JQ("#f_" + HARA.type + "_mins_1").is(':checked')) {
		valid = false;
		BC.debug('HARA.haveRisk(): Missing mins', '', 64);
	    }
	} else if (valid && ALL.mobile) {
	    BC.debug('HARA.haveRisk(): Missing infos in step?:', ALL.steps, 256);
	}
	//if (valid && ! JQ("#div_" + HARA.type + "_risk input[name='" + HARA.type + "_auw']").is(':checked')) {
	//    if (! HARA.dry) {
	//	ALL.showHint('Hausrat: Bitte die Bauart / Außenwände angeben.', 1);
	//    }
	//    BC.debug('HARA.haveRisk(): Missing hara_auw', null, 64);
	//    valid = false;
	//}
	if (valid && ALL.mobile && ALL.steps[0] == 1) {
	    BC.debug('HARA.haveRisk(): Mobile in div_1, querying PLZ and WF', '', 64);
	} else if (valid && ! JQ("input[name='" + HARA.type + "_ded']").is(':checked')) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte die Bauart der Bedachung angeben.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing hara_ded', null, 64);
	    if (! ALL.mobile) valid = false;
	}
	//if (valid && ! JQ("#div_" + HARA.type + "_risk input[name='" + HARA.type + "_mins']").is(':checked')) {
	if (valid && ! JQ("#f_" + HARA.type + "_mins_1").is(':checked')) {
	    if (! HARA.dry) {
		ALL.showHint('Hausrat: Bitte angeben, ob Mindestsicherungen vorhanden oder nicht.', 1);
	    }
	    BC.debug('HARA.haveRisk(): Missing hara_mins', '', 64);
	    if (! ALL.mobile) valid = false;
	}
	if (valid && PRIV.vv.vv3 && PRIV.vv.vv3 != 'keine Vorversicherung') {
	    JQ('#div_' + HARA.type + '_vv4').show();
	    if (JQ('#f_' + HARA.type + '_vv4').val()) {
		PRIV.vv.vv4 = JQ('#f_' + HARA.type + '_vv4').val();
		JQ('#f_' + HARA.type + '_f_1').prop('checked', true);
		JQ('#div_' + HARA.type + '_vers').show();
	    } else {
		JQ('#f_' + HARA.type + '_f_1').prop('checked', false);
		JQ('#div_' + HARA.type + '_vers').hide();
	    }
	} else if (valid && PRIV.vv.vv3 == 'keine Vorversicherung') {
	    JQ('#f_' + HARA.type + '_vv4').val('');
	    JQ('#div_' + HARA.type + '_vv4').hide();
	}
	if (valid) {
	    JQ('#f_' + HARA.type + '_f_1').prop({disabled: false, checked: true});
	} else {
	    JQ('#f_' + HARA.type + '_f_1').prop({disabled: true, checked: false});
	}
	BC.debug('HARA.haveRisk(' + HARA.type + '): =>', valid, 64);
	HARA.o_possible = valid;
	return valid;
    },

    init: function(type) {
        PRIV.hideLogoutAndAdministration();
    	if (type) {
    		HARA.type = type;
		}
		if (isEsg && isEsg === 1) {
			JQ('#f_hara_esg').prop('checked', true)
			JQ('#f_hara1_esg').prop('checked', true)
			JQ('#f_hara2_esg').prop('checked', true)
		}
    	PRIV.createBundleRabattFieldsForBranch('hara');
    	PRIV.createBundleRabattFieldsForBranch('hara1');
    	PRIV.createBundleRabattFieldsForBranch('hara2');
        if (ALL.mobile && ALL.branch.slice(0, 4) != HARA.branch) return;
        HARA.setFahrradHoechstbeschaedigung();
        JQ('#div_hara_vers').change(HARA.change);
        JQ('#div_hara1_vers').change(HARA.change);
        JQ('#div_hara2_vers').change(HARA.change);
        JQ('#div_hara2_plus').change(HARA.showBikeDiv);
        JQ("#f_hara_wf").change(HARA.chkWF);
        JQ("#f_hara1_wf").change(HARA.chkWF);
        JQ("#f_hara2_wf").change(HARA.chkWFVS);
        JQ("#f_hara2_wf2").change(HARA.chgWF2);
        JQ("#f_hara2_vs").change(HARA.chkWFVS);
        JQ('#f_hara2_el_1').click(function () {
            // CASE premium & el
            if (JQ('#f_hara2_plus_0').is(':checked')) {
                JQ('#unbenannte_gefahren').show();
            }
            ALL.notifyHeight();
        })
        JQ('#f_hara2_el_0').click(function () {
            // CASE premium & not el
            if (JQ('#f_hara2_plus_0').is(':checked')) {
                JQ('#f_hara2_unbenannte_gefahren_0').prop('checked', true);
                JQ('#unbenannte_gefahren').hide();
            }
            ALL.notifyHeight();
        })
        JQ('#f_hara2_plus_1').click(function () {
            JQ('#div_hara2_marktgarantie').show();
            JQ('#f_hara2_unbenannte_gefahren_1').prop('checked', true);
            JQ('#unbenannte_gefahren').hide();
            ALL.notifyHeight();
        })
        JQ('#f_hara2_plus_0').click(function () {
            JQ('#div_hara2_marktgarantie').hide();
            JQ('#f_hara2_marktgarantie_1').prop('checked', false);

            // CASE premium & not el
            if (JQ('#f_hara2_el_0').is(':checked')) {
                JQ('#f_hara2_unbenannte_gefahren_0').prop('checked', true);
                JQ('#unbenannte_gefahren').hide();
            }
            // CASE premium & el
            else {
                JQ('#unbenannte_gefahren').show();
            }
            ALL.notifyHeight();
        })
        BC.debug('HARA.init() for', HARA.type, 64);
        if (!ALL.mobile) {
            ALL.chgProduct('hara', null);
            ALL.chgProduct('hara1', null);
            ALL.chgProduct('hara2', null);
            return;
        } else if (!JQ('#div_hara2_vers').length) {
            return;
        }
        HARA.type = HARA.branch = JQ('#f_branch').val();
        ALL.chgProduct(HARA.type, null);
        ALL.chgMobButton('#btn_fwd_1', false);
        JQ('#f_' + HARA.type + '_wf').keyup(HARA.chkKeys);
        JQ('#f_' + HARA.type + '_plz').keyup(HARA.chkKeys);
        JQ('#f_' + HARA.type + '_start').val(tomorrow);
        JQ('#f_' + HARA.type + '_ende').val(in3year);
		//JQ('#div_4 input').keyup(HARA.chkKeys);
        JQ('.box input').keyup(ALL.chkDivReady2);
        if (JQ('#f_' + HARA.type + '_dnls').length &&
            JQ('#f_' + HARA.type + '_dnls').is(':checked')) JQ('#f_' + HARA.type + '_ende').val(in3year);
        if (HARA.type === 'hara2') {
            JQ('#a_da_wording').click(function(e) {
                e.preventDefault();
                var bparts = PRIV.branch + (PRIV.bparts[PRIV.branch].length ? '-' + PRIV.bparts[PRIV.branch].join('-') : '');
                BC.debug('PRIV.showDAform(): PRIV.barts, bparts =', [PRIV.bparts, bparts], 64);
                window.open('/TR/getzip?zip=B-' + bparts + '.zip&friendlyName=VersBed-Hausrat', '_new');
                PRIV.wd_read = true;
                ALL.chkDivReady('a_da_wording', true);
                ALL.chgMobButtons(ALL.branch);
            });
        } else {
            JQ('#a_da_wording').click(function() {
                PRIV.wd_read=true;
                ALL.chkDivReady('a_da_wording', true);
                ALL.chgMobButtons(ALL.branch);
            });
		}
		ALL.notifyHeight();
    },

    recalc: function() {
	BC.debug('HARA.recalc():', ALL.steps, 64);
	if (! HARA.canCalc()) {
	    BC.debug('HARA.recalc():', 'Cannot calc - check logs!', 16);
	    return;
	}
	var sa = PRIV.make_sa(HARA.type);

	if (JQ('#f_hara2_frd_vs').val() === null) {
		sa.push({
			name: 'hara2_frd_vs',
			value: "0"
		})
	}

	if (ALL.mobile && ALL.steps[0] < 2 && ! JQ("#f_" + HARA.type + "_mins_1").is(':checked')) {
	    sa.push({'name': HARA.type + '_mins', 'value': '1'});
	}
	if (ALL.mobile && ALL.steps[0] < 2 &&
	    ! JQ("#f_" + HARA.type + "_ded_1").is(':checked')) {
	    sa.push({'name': HARA.type + '_ded', 'value': '1'});
	}
	BC.debug('HARA.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, PRIV.setPremium);
	ALL.chkContactData();
	ALL.notifyHeight();
    },

    reset: function() {
	BC.debug('HARA.reset()', '...starting...', 256);
	HARA.change();
    },

    setBike0: function() {
	JQ('#f_' + HARA.type + '_frd_vs').val('0');
	JQ('#f_' + HARA.type + '_frd_wf').val('0');
    },

    setChkFlds: function () {
		// Belege Felder in "Angaben überprüfen"
		// Aufruf teilweise in ALL.set_HNR
		if (ALL.mobile) {
			if (JQ('#f_' + HARA.type + '_plus_1').is(':checked') === true && JQ('#f_hara2_marktgarantie_1').prop('checked') === true) {
				var marktgarantieText = 'Die Marktgarantie ist versichert'
			} else {
				var marktgarantieText = 'Die Marktgarantie ist nicht versichert'
			}
			if (JQ('#f_' + HARA.type + '_el_1').is(':checked') === true && JQ('#f_hara2_unbenannte_gefahren_1').prop('checked') === true) {
				var gefahrenText = 'Unbenannte Gefahren sind versichert.'
			} else {
				var gefahrenText = '------'
			}
			JQ('#m098_marktgarantie').text(marktgarantieText);
			JQ('#m098_unbenannte_gefahren').text(gefahrenText);
			JQ('#m098_vo').text(ALL.adr.plz + ' ' + ALL.adr.ort + ', ' + ALL.adr.str + ' ' + ALL.adr.hnr);
			JQ('#m098_wf').text(JQ('#f_' + HARA.type + '_wf').val());
			JQ('#m098_itype').text(JQ('#f_' + HARA.type + '_itype_1').is(':checked') ? 'Einfamilienhaus' : 'Wohnung in einem Mehrfamilienhaus');
			JQ('#m098_vs').text(JQ('#f_' + HARA.type + '_vs').val() + ' €');
			JQ('#m098_tarif').text('Premium ' + (JQ('#f_' + HARA.type + '_plus_1').is(':checked') ? 'Plus' : ''));
			JQ('#m098_frd').text(JQ('#f_' + HARA.type + '_frd_vs').val() + '% der Versicherungssumme');
			JQ('#m098_sb').text('Selbstbeteiligung ' + JQ('#f_' + HARA.type + '_sb').val() + ',00 €');
			JQ('#m098_glas').text(JQ('#f_' + HARA.type + '_glas_1').is(':checked') ? 'JA' : 'NEIN');
			if (JQ('#f_' + HARA.type + '_el_1').is(':checked')) {
				JQ('#m098_el').text('Weitere Gefahren sind versichert.');
			} else {
				JQ('#m098_el').text('------');
			}
			ALL.setChkFlds(HARA.type);
			ALL.notifyHeight();
		}
    },

	setFahrradHoechstbeschaedigung: function () {
        var limit = parseInt(JQ('#f_hara2_frd_vs').attr('data-limit'));
        var currentValue = parseInt(JQ('#f_hara2_frd_vs').val());

        if (!isNaN(limit) && !isNaN(currentValue) && currentValue === limit) {
            JQ('#s_' + HARA.type + '_frd_val').text('12.500,00 €');
            return;
        }

    	if (parseInt(JQ('#f_hara2_frd_vs_kasko option:selected').val()) > 0) {
			JQ('#s_' + HARA.type + '_frd_val').text('0,00 €');
		} else {
			JQ('#s_' + HARA.type + '_frd_val').text(ALL.flt2cur(JQ('#f_hara2_frd_vs option:selected').val() * 10 * parseInt(JQ('#f_' + HARA.type + '_vs').val())));
		}
	},

    setFhrdOptions: function() {
		BC.debug('HARA.setFhrdOptions() called with HARA.frd = ' + HARA.frd);
		// Fill option-list under select ID f_hara2_frd_vs
        // Nun auch bei Plus-Variante 0% Fahrrad Standard... (19.07.2019)
		//var s = HARA.plus ? 1 : 0;

		if (HARA.frd >= 2) return;
		var currentValue = parseInt(JQ('#f_hara2_frd_vs').val());
		var priceLimit = 12500;

		// CASE The VS changed and the selected option is now not displayed anymore
		if (!isNaN(currentValue) && (currentValue - 1) * HARA.vs * 10 > priceLimit) {
			// Reset to initial selection
			JQ('#o_hara2_frd_'+ currentValue +'p').prop('selected', false);
			JQ('#o_hara2_frd_'+ 1 +'p').prop('selected', true);
		}

		var e = 10;
		JQ('#f_hara2_frd_vs').attr('data-limit', 'undefined');


		for (var s = 0; s <= e; s++) {
			JQ('#o_hara2_frd_'+ s +'p').val(s);
			JQ('#o_hara2_frd_'+ s +'p').text(s + '% = ' + ALL.flt2cur(s * HARA.vs * 10));
			JQ('#o_hara2_frd_'+ s +'p').attr('disabled', false);
			JQ('#o_hara2_frd_'+ s +'p').show();

			if ((s-1) * HARA.vs * 10 >= priceLimit) {
			    JQ('#o_hara2_frd_'+ s +'p').attr('disabled', true);
			    JQ('#o_hara2_frd_'+ s +'p').text(s + '% (nicht versicherbar)');
			    JQ('#o_hara2_frd_'+ s +'p').hide();
			} else if (s * HARA.vs * 10 > priceLimit) {
			    JQ('#o_hara2_frd_'+ s +'p').text(s + '% = ' + ALL.flt2cur(priceLimit));
			    JQ('#f_hara2_frd_vs').attr('data-limit', s);
			}


			if (s === 0) {
				JQ('#o_hara2_frd_'+ s +'p').prop('disabled', true);
			}
			if (s === 1) {
				JQ('#o_hara2_frd_'+ s +'p').text(s + '% = ' + ALL.flt2cur(s * HARA.vs * 10) + ' beitragsfrei');
			}
		}

		if (!ALL.mobile) {
			JQ('#f_hara2_frd_vs_kasko > option').each(function (i, e) {
				JQ(e).text(i + '% = ' + ALL.flt2cur(i * HARA.vs * 10))

				JQ('#s_' + HARA.type + '_frd_kasko_val').text(ALL.flt2cur(JQ('#f_hara2_frd_vs_kasko option:selected').val() * 10 * parseInt(JQ('#f_' + HARA.type + '_vs').val())));
			})
		}

		HARA.setFahrradHoechstbeschaedigung();

		JQ('#f_hara2_frd_vs').change(function () {
			var limit = parseInt(JQ(this).attr('data-limit'));
			var currentValue = parseInt(JQ(this).val());

			if (!isNaN(limit) && !isNaN(currentValue) && currentValue === limit) {
				ALL.showInfo("Hinweis: Die Versicherungssumme für den Fahrraddiebstahl beträgt höchstens 12.500 €.");;
			}

			HARA.setFahrradHoechstbeschaedigung();
		})
		ALL.notifyHeight();
    },

    setPremium: function(data) {
	BC.debug('HARA.setPremium():', data, 64);
 	ALL.chkError(data);
	if (data.ERROR) {
	    return;
	}
	//if (ALL.mobile) PRIV.showPremium(data);
	JQ.each(data, function(key, val) {
	    if (key == 'DirA' && val && val.length) {
            PRIV.setDirAnfrage(val);
            return;
	    } else if (JQ('#f_' + HARA.type + '_' + key).length) {
	        if (key === 'net2') {
	            var netHara = (val.val - (data['net2_glas'].val || 0)).toFixed(2);
	            JQ('#f_' + HARA.type + '_' + key).text(netHara + ' €');
	        } else {
		        JQ('#f_' + HARA.type + '_' + key).text(val.str);
		    }
	    }
	    if (key == 'mpr2' && val.val) {
		JQ('#l_' + HARA.type + '_net2').text('Jährliche Nettoprämie Hausratversicherung (Mindestprämie!):');
	    } else if (key == 'mpr2') {
		JQ('#l_' + HARA.type + '_net2').text('Jährliche Nettoprämie Hausratversicherung:');
	    }
	    if (key == 'brt1' && val.str) {
		ALL.chgProduct(HARA.type, val.str);
	    }
	});
    },

    setType: function() {
	if (JQ('#f_hara_plz').is(':visible')) {
	    HARA.type = 'hara';
	} else if (JQ('#f_hara1_plz').is(':visible')) {
	    HARA.type = 'hara1';
	} else if (JQ('#f_hara2_plz').is(':visible')) {
	    HARA.type = 'hara2';
	}
    },

    showBikeDiv: function(t) {
	BC.debug('HARA.showBikeDiv() called', t, 64);
	JQ('#div_' + HARA.type + '_frd_vs').hide();
	JQ('#div_' + HARA.type + '_frd_wf').hide();
	HARA.setFhrdOptions();
	if (! t) {
	    HARA.frd = 1;
	    return;
	} else if (typeof(t) === 'string') {
	    JQ('#div_' + HARA.type + '_frd_vs').show();
	    //if (JQ('#f_' + HARA.type + '_frd_vs').html()) return;
	}

	if (JQ('#f_hara2_frd_vs').val() === null) {
		HARA.frd = 0
	}

	if (t === 'wf') {
		HARA.frd = parseInt(JQ('#f_' + HARA.type + '_frd_wf').val());
	}
	if (t == 'vs') {
	    HARA.setFhrdOptions();
	    JQ('#div_' + HARA.type + '_frd_vs').show();
	} else if (t == 'wf') {
	    JQ('#div_' + HARA.type + '_frd_wf').show();
	}
	if (! HARA.frd && HARA.plus && t == 'wf') {
	    JQ('#f_' + HARA.type + '_frd_wf').val('500');
	//} else if (! HARA.frd && HARA.plus) {
	//    JQ('#f_' + HARA.type + '_frd_vs').val('1');
	}
	ALL.notifyHeight();
    }
};
